const DEFAULT_THEME = 'system';

export const resolveTheme = (theme = 'system') => {
  if (theme === 'dark' || theme === 'light') {
    return theme;
  }

  if (
    typeof window !== 'undefined' &&
    typeof window.matchMedia === 'function' &&
    window.matchMedia('(prefers-color-scheme: dark)').matches
  ) {
    return 'dark';
  }

  return 'light';
};

export const getSavedThemePreference = () => {
  if (typeof window === 'undefined' || !window.localStorage) {
    return DEFAULT_THEME;
  }

  try {
    const saved = window.localStorage.getItem('userPreferences');
    if (!saved || !saved.startsWith('{')) {
      return DEFAULT_THEME;
    }

    const preferences = JSON.parse(saved);
    return preferences.theme || DEFAULT_THEME;
  } catch {
    return DEFAULT_THEME;
  }
};

export const applyTheme = (theme = 'system') => {
  if (typeof document === 'undefined') {
    return 'light';
  }

  const effectiveTheme = resolveTheme(theme);
  const isDark = effectiveTheme === 'dark';
  const root = document.documentElement;
  const appRoot = document.getElementById('root');

  root.classList.toggle('dark', isDark);
  document.body.classList.toggle('dark', isDark);
  root.style.removeProperty('background-color');
  document.body.style.removeProperty('background-color');
  appRoot?.style.removeProperty('background-color');

  return effectiveTheme;
};
